import { Record } from "@common/data-models/records/record";
import { Subscription, Subject } from "rxjs";
import { CollectionRecord } from "@suite/common/data-models/records/collection-record";
import { FieldDef } from "@suite/common/data-models/service/field-def";
import { Table } from "@suite/common/data-models/complex-types/table";

export class NewlyCreatedRecords {
    public changesSub: Subscription = new Subscription();
    public resetCostSubject = new Subject<void>();
    public items: Array<Record> = [];
    public itemsGuids: { [id: string]: boolean } = {};

    public parentCostProps = [];
    private childCostProps = [];
    public costView: boolean = true;

    private _cost: number = -1;
    public get cost(): number {
        if (this._cost > -1) return this._cost;

        if ((this.items.length > 0) &&
            ((this.parentCostProps && this.parentCostProps.length > 0) ||
                (this.childCostProps && this.childCostProps.length > 0))) {
            this._cost = 0;
            this.items.forEach((item) => {
                let props: Array<FieldDef> = []
                if (item.isCollection) {
                    props = this.parentCostProps;
                    let children = (<CollectionRecord>item).getChildren();
                    for (let child of children) {
                        for (let prop of this.childCostProps) {
                            let costProp = child.getAs<Table>(prop.ID);
                            if (costProp) {
                                costProp.calculateCost(Record.globalTablesService.getListColumnsForSpecialField(prop.ID));
                                this._cost += costProp.totalCost;
                            }
                        }
                    }
                }
                if (item.isCollection) props = this.parentCostProps;
                for (let prop of props) {
                    let costProp = item.getAs<Table>(prop.ID);
                    if (costProp) {
                        costProp.calculateCost(Record.globalTablesService.getListColumnsForSpecialField(prop.ID));
                        this._cost += costProp.totalCost;
                    }
                }
            })
        }
        if (this.items.length == 0 && ((this.parentCostProps && this.parentCostProps.length) > 0 || (this.childCostProps && this.childCostProps.length > 0))) this._cost = 0;
        return this._cost;
    }

    public set cost(v: number) {
        this._cost = v;
    }


    public addRecord(rec: Record, idx?: number) {
        if (rec) {
            if (!this.itemsGuids) {
                this.itemsGuids = {};
            }
            if (!this.items) {
                this.items = [];
            }
            if (!this.itemsGuids[rec.guid]) {
                if (!idx) {
                    this.items.push(rec);
                    this.itemsGuids[rec.guid] = true;
                } else {
                    this.items.splice(idx + 1, 0, rec);
                    this.itemsGuids[rec.guid] = true;
                }
            }
            this.registerTiles();
        }
    }

    public dispose() {
        this.items = [];
        this.itemsGuids = {};
        this.unRegisterTiles();
    }

    public remove(rec: Record) {
        if (this.itemsGuids[rec.guid]) {
            delete this.itemsGuids[rec.guid];
        }

        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].guid == rec.guid) {
                this.items.splice(i, 1);
                break;
            }
        }
        this.registerTiles();
    }

    public registerTiles() {
        if (this.changesSub) this.changesSub.unsubscribe();
        this.changesSub = new Subscription();
        this.items.forEach((item) => {
            let tmpSub = item.changeObserver.subscribe(() => {
                this.registerTiles();
                this.resetCostSubject.next();
            });
            if (item.isCollection) {
                let children = (<CollectionRecord>item).getChildren();
                for (let child of children) {
                    let assignmentSub = child.changeObserver.subscribe(() => {
                        this.resetCostSubject.next();
                    });
                    this.changesSub.add(assignmentSub);
                }
            }
            this.changesSub.add(tmpSub);
        });
        this.resetCostSubject.next();
    }

    public unRegisterTiles() {
        this.resetCostSubject.next();
    }

    constructor() {
        if(Record.globalTablesService) {
            this.parentCostProps = Record.globalTablesService.getSpecialPropertiesFor("Topic").filter((prop) => { return prop.Validation.toUpperCase() == "COST" });
            this.childCostProps = Record.globalTablesService.getSpecialPropertiesFor('Assignment').filter((prop) => { return prop.Validation.toUpperCase() == "COST" });
            if ((this.parentCostProps && this.parentCostProps.length > 0) || (this.childCostProps && this.childCostProps.length > 0)) {
                this.registerTiles();
                this.resetCostSubject.asObservable().subscribe(() => {
                    this.cost = -1;
                });
                this.costView = Record.globalTablesService.securityPrivileges[Record.nomWebServicesJson.PSTGroup].cost.read;
            }
        }
    }

    

}
